// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-modal-root .ant-modal-content {\n  z-index: 1000000000000000000000000; }\n\n.modal-backdrop {\n  z-index: auto; }\n\n.studioModal {\n  z-index: auto; }\n\n.lsf-tooltip {\n  z-index: 100000000000000000000000; }\n\n.lsf-keys__key {\n  color: black; }\n", ""]);
// Exports
module.exports = exports;
